import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Zone, ZoneProjectReport } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  reports: ZoneProjectReport[];
  retrieveZoneProjectsReports(
    request: Boundaries["retrieveZoneProjectsReports"]["request"],
  ): void;
}

function useRetrieveZoneProjectsReports(zone: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isZoneProjectsReportsRetrievalRequestPending(zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isZoneProjectsReportsRetrievalRequestSuccess(zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isZoneProjectsReportsRetrievalRequestFailure(zone),
    ),
    reports: useSelector(() => selector.getZoneProjectsReports(zone)),
    retrieveZoneProjectsReports: core.retrieveZoneProjectsReports,
  };
}

export { useRetrieveZoneProjectsReports };
